/**
 * Per-session per-dispensary suppression for the order-type takeover modal
 * (ECOMM-9816). The key tracks "engagement" (any submit OR any dismiss), not
 * mere display: simply rendering the modal does not suppress future prompts -
 * a user must actively interact with it. Once engaged for a dispensary, no
 * re-prompts for the rest of the browser session; new sessions enroll fresh
 * (each is an independent A/B opportunity). Mirrors `discount-modal-tracking.ts`.
 *
 * Key registered in apps/marketplace/docs/cookies-and-storage.md.
 */

const ORDER_TYPE_TAKEOVER_ENGAGED_KEY = 'orderTypeTakeoverEngaged';

const getEngagedDispensaryIds = (): Set<string> => {
  try {
    const stored = sessionStorage.getItem(ORDER_TYPE_TAKEOVER_ENGAGED_KEY);
    return stored ? new Set(JSON.parse(stored)) : new Set();
  } catch {
    return new Set();
  }
};

export const markTakeoverAsEngaged = (dispensaryId: string | null | undefined): void => {
  if (!dispensaryId) return;
  try {
    const engaged = getEngagedDispensaryIds();
    engaged.add(String(dispensaryId));
    sessionStorage.setItem(ORDER_TYPE_TAKEOVER_ENGAGED_KEY, JSON.stringify([...engaged]));
  } catch {
    // Silently fail if sessionStorage is unavailable
  }
};

export const hasTakeoverBeenEngaged = (dispensaryId: string | null | undefined): boolean => {
  if (!dispensaryId) return false;
  return getEngagedDispensaryIds().has(String(dispensaryId));
};

export const clearEngagedTakeoverDispensaryIds = (): void => {
  try {
    sessionStorage.removeItem(ORDER_TYPE_TAKEOVER_ENGAGED_KEY);
  } catch {
    /* noop */
  }
};
